import React, { Component } from 'react';
import Grid from '@material-ui/core/Grid';
import Card from '@material-ui/core/Card';
import CardHeader from '@material-ui/core/CardHeader';
import CardContent from '@material-ui/core/CardContent';
import TextField from '@material-ui/core/TextField';
import Button from '@material-ui/core/Button';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Autocomplete from '@material-ui/lab/Autocomplete';

//import { ProjectSelect } from '../components/ProjectSelect'
//import { MissionSelect } from '../components/MissionSelect';

//import { postRequest, getRequest, URL } from "../api/helper";

import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

export class AssignMissionPage extends Component {

    constructor(props) {
        super(props);
        this.state = {
            missionMonitor: null,
            missionQualityController: null,
            missionQualityAssurance: null,
            stakeholderName: "",
            stakeholderSurname: "",
            stakeholderCompany: "",
            stakeholderEmail: "",
            stakeholders: [],
            projects: [],
            missions: [],
            users: [],
            monuserid: 0,
            qcuserid: 0,
            qauserid: 0,
            isFetching: false,
        };
    }

    async componentDidMount() {

        let pageTokenAuthData = {
            operation: "AuthCheckToken"
        };

        await fetch(global.variables.API_CHECKTOKEN, {
            method: "POST",
            headers: {
                Authorization: "Bearer " + localStorage.getItem("authtoken"),
                Accept: "application/json",
                "Content-Type": "application/json"
            },
            body: JSON.stringify(pageTokenAuthData)
        })
            .then(response => response.json())
            .then(result => {
                if (result.resultstate > 0 ||
                    result.authresp === 2) {
                    window.location.href = "/login";
                }
            }).catch(() => {
                window.location.href = "/login";
            });

        //const projects = [
        //    { title: 'Project 1', no: 1 },
        //    { title: 'Project 2', no: 2 },
        //    { title: 'Project 3', no: 3 },
        //    { title: 'Project 4', no: 4 },
        //    { title: 'Project 5', no: 5 }
        //];
        //const beneficiaries = [
        //    { name: "Emre", surName: "Yılmaz", company: "Kuartek", eMail: "emre@kuartekdigital.com" },
        //    { name: "Çağlar ", surName: "İspirli", company: "Siu", eMail: "caglarispirli@gmail.com" }
        //]

        //await this.setState({
        //    //projects: projects,
        //    beneficiaries
        //});

        //await fetch("/api/AssignMission/LoadPageJSON", {
        //    method: "POST",
        //    headers: {
        //        Authorization: "Bearer " + localStorage.getItem("authtoken"),
        //        Accept: "application/json",
        //        "Content-Type": "application/json"
        //    },
        //    body: JSON.stringify(this.state)
        //})
        //    .then(response => response.json())
        //    .then(result => {
        //        console.log(result);
        //    });

        //await this.loadPageProjects();
        //await this.loadPageMissions();
        await this.loadPageUsers();
    }

    handleChange = (e) => {
        e.persist();
        this.setState({ [e.target.name]: e.target.value });
    }

    //handleProjectSelectChange = async (e, v) => {
    //    e.persist();

    //    //console.log(e.target.idProjectDetails);

    //    if (v !== undefined & v !== null) {
    //        //if (v !== null) {
    //        //await this.setState({ selectedprojectid: v.idProjectDetails });
    //        await this.setState({ selectedmissionid: v.idMissionDetails });
    //        //    //console.log(" :: " + e.target.name + " " + e.target.value + " " + v.idProjectDetails + " " + e.target.textContent);

    //        //    //for (var propertyKey in v) {
    //        //    //    console.log(v + " " + propertyKey + " " + v[propertyKey]);
    //        //    //}

    //        //await this.loadPageBeneficiaries();
    //        //await this.loadPageMONQC();

    //        await this.loadPageMissions();
    //    } else {
    //        await this.setState({
    //            selectedmissionid: -1,
    //            stakeholders: [],
    //            projectMonitor: null,
    //            projectQualityController: null,
    //            projectQualityAssurance: null
    //        });
    //    }
    //}

    handleMissionSelectChange = async (e, v) => {
        e.persist();

        //console.log(e.target.idProjectDetails);

        if (v !== undefined & v !== null) {
            //if (v !== null) {
            await this.setState({ selectedmissionid: v.idMissionDetails });
            //    //console.log(" :: " + e.target.name + " " + e.target.value + " " + v.idProjectDetails + " " + e.target.textContent);

            //    //for (var propertyKey in v) {
            //    //    console.log(v + " " + propertyKey + " " + v[propertyKey]);
            //    //}

            await this.loadPageStakeholders();
            await this.loadPageMONQCQA();
        } else {
            await this.setState({
                selectedmissionid: -1,
                stakeholders: [],
                missionMonitor: null,
                missionQualityController: null,
                missionQualityAssurance: null
            });
        }
    }

    handleMONUserChange = (e, v) => {
        e.persist();
        if (v !== undefined & v !== null) {
            this.setState({
                monuserid: v.idLoginCredentials,
                missionMonitor: v
            });
        } else {
            this.setState({
                monuserid: -1,
                missionMonitor: null
            });
        }
    }

    handleQCUserChange = (e, v) => {
        e.persist();
        if (v !== undefined & v !== null) {
            this.setState({
                qcuserid: v.idLoginCredentials,
                missionQualityController: v
            });
        } else {
            this.setState({
                qcuserid: -1,
                missionQualityController: null
            });
        }
    }

    handleQAUserChange = (e, v) => {
        e.persist();
        if (v !== undefined & v !== null) {
            this.setState({
                qauserid: v.idLoginCredentials,
                missionQualityAssurance: v
            });
        } else {
            this.setState({
                qauserid: -1,
                missionQualityAssurance: null
            });
        }
    }

    //handleSaveOnClick = () => {
    //    console.log(this.state);

    //    //fetch(global.variables.API_ASSIGNMISSION_USERS, {
    //    //    method: "POST",
    //    //    headers: {
    //    //        Authorization: "Bearer " + localStorage.getItem("authtoken"),
    //    //        Accept: "application/json",
    //    //        "Content-Type": "application/json"
    //    //    },
    //    //    body: JSON.stringify(this.state)
    //    //})
    //    //    .then(response => response.json())
    //    //    .then(result => {
    //    //        console.log(result);
    //    //    });
    //}

    handleAddStakeholdersOnClick = () => {
        this.setState({ isFetching: true });
        console.log(this.state);

        fetch(global.variables.API_ASSIGNMISSION_STAKEHOLDERS_ADD, {
            method: "POST",
            headers: {
                Authorization: "Bearer " + localStorage.getItem("authtoken"),
                Accept: "application/json",
                "Content-Type": "application/json"
            },
            body: JSON.stringify(this.state)
        })
            .then(response => response.json())
            .then(result => {
                console.log(result);

                if (result.resultstate === 0) {
                    toast.success("Success!", {
                        position: toast.POSITION.BOTTOM_RIGHT
                    });
                } else {
                    toast.error("Failed!", {
                        position: toast.POSITION.BOTTOM_RIGHT
                    });
                }

                this.loadPageStakeholders();
            });
        this.setState({ isFetching: false });
    }

    handleRemoveStakeholdersOnClick = (e) => {
        this.setState({ isFetching: true });
        var removeObject = { removeStakeholdersId: e.currentTarget.dataset.id };

        fetch(global.variables.API_ASSIGNMISSION_STAKEHOLDERS_REMOVE, {
            method: "POST",
            headers: {
                Authorization: "Bearer " + localStorage.getItem("authtoken"),
                Accept: "application/json",
                "Content-Type": "application/json"
            },
            body: JSON.stringify(removeObject)
        })
            .then(response => response.json())
            .then(result => {
                console.log(result);

                if (result.resultstate === 0) {
                    toast.success("Success!", {
                        position: toast.POSITION.BOTTOM_RIGHT
                    });
                } else {
                    toast.error("Failed!", {
                        position: toast.POSITION.BOTTOM_RIGHT
                    });
                }

                this.loadPageStakeholders();
            });
        this.setState({ isFetching: false });
    }

    handleMONUserRecord = (e) => {
        this.setState({ isFetching: true });
        console.log(this.state);
        //console.log("MonUserId: " + this.state.monuserid);

        fetch(global.variables.API_ASSIGNMISSION_MON, {
            method: "POST",
            headers: {
                Authorization: "Bearer " + localStorage.getItem("authtoken"),
                Accept: "application/json",
                "Content-Type": "application/json"
            },
            body: JSON.stringify(this.state)
        })
            .then(response => response.json())
            .then(result => {
                console.log(result);

                if (result.resultstate === 0) {
                    toast.success("Success!", {
                        position: toast.POSITION.BOTTOM_RIGHT
                    });
                } else {
                    toast.error("Failed!", {
                        position: toast.POSITION.BOTTOM_RIGHT
                    });
                }

                this.loadPageMONQCQA();
            });
        this.setState({ isFetching: false });
    }

    handleQCUserRecord = (e) => {
        this.setState({ isFetching: true });
        console.log(this.state);

        fetch(global.variables.API_ASSIGNMISSION_QC, {
            method: "POST",
            headers: {
                Authorization: "Bearer " + localStorage.getItem("authtoken"),
                Accept: "application/json",
                "Content-Type": "application/json"
            },
            body: JSON.stringify(this.state)
        })
            .then(response => response.json())
            .then(result => {
                console.log(result);

                if (result.resultstate === 0) {
                    toast.success("Success!", {
                        position: toast.POSITION.BOTTOM_RIGHT
                    });
                } else {
                    toast.error("Failed!", {
                        position: toast.POSITION.BOTTOM_RIGHT
                    });
                }

                this.loadPageMONQCQA();
            });
        this.setState({ isFetching: false });
    }

    handleQAUserRecord = (e) => {
        this.setState({ isFetching: true });
        console.log(this.state);

        fetch(global.variables.API_ASSIGNMISSION_QA, {
            method: "POST",
            headers: {
                Authorization: "Bearer " + localStorage.getItem("authtoken"),
                Accept: "application/json",
                "Content-Type": "application/json"
            },
            body: JSON.stringify(this.state)
        })
            .then(response => response.json())
            .then(result => {
                console.log(result);

                if (result.resultstate === 0) {
                    toast.success("Success!", {
                        position: toast.POSITION.BOTTOM_RIGHT
                    });
                } else {
                    toast.error("Failed!", {
                        position: toast.POSITION.BOTTOM_RIGHT
                    });
                }

                this.loadPageMONQCQA();
            });
        this.setState({ isFetching: false });
    }

    loadPageStakeholders = () => {
        fetch(global.variables.API_ASSIGNMISSION_LOADPAGE_STAKEHOLDERS, {
            method: "POST",
            headers: {
                Authorization: "Bearer " + localStorage.getItem("authtoken"),
                Accept: "application/json",
                "Content-Type": "application/json"
            },
            body: JSON.stringify(this.state)
        })
            .then(response => response.json())
            .then(result => {
                console.log(result);

                this.setState({ stakeholders: result.missionstakeholders });
            });
    }

    loadPageUsers = () => {
        let pageData = { operation: "LoadPageUsers" };

        fetch(global.variables.API_ASSIGNMISSION_LOADPAGE_USERS, {
            method: "POST",
            headers: {
                Authorization: "Bearer " + localStorage.getItem("authtoken"),
                Accept: "application/json",
                "Content-Type": "application/json"
            },
            body: JSON.stringify(pageData)
        })
            .then(response => response.json())
            .then(result => {
                console.log(result);

                this.setState({ users: result.listofusers });
            });
    }

    //loadPageProjects = async () => {
    //    let pageData = { operation: "GetListOfProjects" };

    //    await fetch(global.variables.API_PROJECTDETAILS_GETLISTOFPROJECTS, {
    //        method: "POST",
    //        headers: {
    //            Authorization: "Bearer " + localStorage.getItem("authtoken"),
    //            Accept: "application/json",
    //            "Content-Type": "application/json"
    //        },
    //        body: JSON.stringify(pageData)
    //    })
    //        .then(response => response.json())
    //        .then(result => {
    //            console.log(result);

    //            this.setState({ projects: result.projects });
    //        });
    //}

    //loadPageMissions = async () => {
    //    let pageData = {
    //        operation: "GetListOfMisions",
    //        selectedprojectid: this.state.selectedprojectid
    //    };

    //    await fetch(global.variables.API_PROJECTDETAILS_GETLISTOFMISSIONS, {
    //        method: "POST",
    //        headers: {
    //            Authorization: "Bearer " + localStorage.getItem("authtoken"),
    //            Accept: "application/json",
    //            "Content-Type": "application/json"
    //        },
    //        body: JSON.stringify(pageData)
    //    })
    //        .then(response => response.json())
    //        .then(result => {
    //            console.log(result);

    //            this.setState({ missions: result.missions });
    //        });
    //}

    loadPageMONQCQA = async () => {
        await fetch(global.variables.API_ASSIGNMISSION_LOADPAGE_MONQCQA, {
            method: "POST",
            headers: {
                Authorization: "Bearer " + localStorage.getItem("authtoken"),
                Accept: "application/json",
                "Content-Type": "application/json"
            },
            body: JSON.stringify(this.state)
        })
            .then(response => response.json())
            .then(result => {
                console.log(result);

                if (result.resultstate === 0) {
                    this.setState({
                        missionMonitor: result.monuserassigned[0],
                        missionQualityController: result.qcuserassigned[0],
                        missionQualityAssurance: result.qauserassigned[0]
                    });
                }
            });
    }

    render() {

        const { missionMonitor, missionQualityController, missionQualityAssurance, stakeholderName,
            stakeholderSurname, stakeholderCompany, stakeholderEmail,
            stakeholders,
            //projects,
            users,
            //monuserid,
            //qcuserid,
            //qauserid,
            //missions,
            isFetching } = this.state

        return (
            <Grid container>
                <Grid>
                    <ToastContainer />
                </Grid>
                {
                    //<Grid item xs={12}>
                    //    <ProjectSelect
                    //        title="Please Select Project Title or Project Number"
                    //        projects={projects}
                    //        onchange={this.handleProjectSelectChange.bind(this)}
                    //    />
                    //</Grid>
                    //<Grid item xs={12} className="mt-1">
                    //    <MissionSelect
                    //        title="Please Select Mission"
                    //        missions={missions}
                    //        onchange={this.handleMissionSelectChange.bind(this)}
                    //    />

                    //</Grid>
                }
                <Grid item xs={12} className="mt-1">
                    <Card>
                        <CardHeader title="Add Mission Monitor" className="romis-card-header"></CardHeader>
                        <CardContent>
                            <Grid container spacing={2}>

                                <Grid item xs={10}>

                                    {
                                        //<TextField
                                        //    fullWidth
                                        //    placeholder="E-Mail"
                                        //    margin="normal"
                                        //    onChange={this.handleChange.bind(this)}
                                        //    value={projectMonitor}
                                        //    name="projectMonitor"
                                        ///>
                                    }

                                    <Autocomplete
                                        options={users}
                                        getOptionLabel={option => option.LoginUsername + " " + option.LoginEmail + " " + option.LoginName + " " + option.LoginSurname}
                                        autoComplete
                                        includeInputInList
                                        onChange={this.handleMONUserChange.bind(this)}
                                        renderInput={params => (
                                            <TextField {...params} label="Monitor" margin="normal" fullWidth />
                                        )}
                                        value={missionMonitor}
                                    />

                                </Grid>
                                <Grid item xs={2}>
                                    <Button variant="contained" color="primary" className="mt"
                                        onClick={this.handleMONUserRecord.bind(this)}
                                        disabled={isFetching ? true : false}>Confirm & Add</Button>
                                </Grid>
                            </Grid>
                        </CardContent>
                    </Card>
                </Grid>

                <Grid item xs={12} className="mt-1">
                    <Card>
                        <CardHeader title="Add Mission Quality Controller" className="romis-card-header"></CardHeader>
                        <CardContent>
                            <Grid container spacing={2}>

                                <Grid item xs={10}>

                                    {
                                        //<TextField
                                        //    fullWidth
                                        //    placeholder="E-Mail"
                                        //    margin="normal"
                                        //    onChange={this.handleChange.bind(this)}
                                        //    value={projectQualityController}
                                        //    name="projectQualityController"

                                        ///>
                                    }

                                    <Autocomplete
                                        options={users}
                                        getOptionLabel={option => option.LoginUsername + " " + option.LoginEmail + " " + option.LoginName + " " + option.LoginSurname}
                                        autoComplete
                                        includeInputInList
                                        onChange={this.handleQCUserChange.bind(this)}
                                        renderInput={params => (
                                            <TextField {...params} label="Quality Controller" margin="normal" fullWidth />
                                        )}
                                        value={missionQualityController}
                                    />
                                </Grid>
                                <Grid item xs={2}>
                                    <Button variant="contained" color="primary" className="mt"
                                        onClick={this.handleQCUserRecord.bind(this)}
                                        disabled={isFetching ? true : false}>Confirm & Add</Button>
                                </Grid>
                            </Grid>


                        </CardContent>
                    </Card>
                </Grid>

                <Grid item xs={12} className="mt-1">
                    <Card>
                        <CardHeader title="Add Mission Quality Assurance" className="romis-card-header"></CardHeader>
                        <CardContent>
                            <Grid container spacing={2}>
                                <Grid item xs={10}>
                                    <Autocomplete
                                        options={users}
                                        getOptionLabel={option => option.LoginUsername + " " + option.LoginEmail + " " + option.LoginName + " " + option.LoginSurname}
                                        autoComplete
                                        includeInputInList
                                        onChange={this.handleQAUserChange.bind(this)}
                                        renderInput={params => (
                                            <TextField {...params} label="Quality Assurance" margin="normal" fullWidth />
                                        )}
                                        value={missionQualityAssurance}
                                    />
                                </Grid>
                                <Grid item xs={2}>
                                    <Button variant="contained" color="primary" className="mt"
                                        onClick={this.handleQAUserRecord.bind(this)}
                                        disabled={isFetching ? true : false}>Confirm & Add</Button>
                                </Grid>
                            </Grid>
                        </CardContent>
                    </Card>
                </Grid>

                <Grid item xs={12} className="mt-1">
                    <Card>
                        <CardHeader title="Add Stakeholder" className="romis-card-header"></CardHeader>
                        <CardContent>
                            <Grid container spacing={2}>
                                <Grid item xs={3}>
                                    <TextField
                                        placeholder="Name"
                                        fullWidth
                                        margin="normal"
                                        onChange={this.handleChange.bind(this)}
                                        value={stakeholderName}
                                        name="stakeholderName"
                                    />
                                </Grid>
                                <Grid item xs={3}>
                                    <TextField
                                        placeholder="Surname"
                                        fullWidth
                                        margin="normal"
                                        onChange={this.handleChange.bind(this)}
                                        value={stakeholderSurname}
                                        name="stakeholderSurname"
                                    />
                                </Grid>
                                <Grid item xs={3}>
                                    <TextField
                                        fullWidth
                                        placeholder="Company&Instutition"
                                        margin="normal"
                                        onChange={this.handleChange.bind(this)}
                                        value={stakeholderCompany}
                                        name="stakeholderCompany"
                                    />
                                </Grid>
                                <Grid item xs={2}>
                                    <TextField
                                        fullWidth
                                        placeholder="E-Mail"
                                        margin="normal"
                                        onChange={this.handleChange.bind(this)}
                                        value={stakeholderEmail}
                                        name="stakeholderEmail"
                                    />
                                </Grid>
                                <Grid item xs={1}>
                                    <Button variant="contained" color="primary" className="mt"
                                        onClick={this.handleAddStakeholdersOnClick.bind(this)}
                                        disabled={isFetching ? true : false}>Add</Button>
                                </Grid>
                            </Grid>
                            <Table aria-label="simple table" className="mt-1">
                                <TableHead>
                                    <TableRow>
                                        <TableCell>Name </TableCell>
                                        <TableCell align="right">Surname </TableCell>
                                        <TableCell align="right">Company&Instutition</TableCell>
                                        <TableCell align="right">E-Mail</TableCell>
                                        <TableCell align="right">Options</TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {stakeholders.map(({ idMissionStakeholders, stakeholderName, stakeholderSurname, stakeholderCompany, stakeholderEmail }, index) => {
                                        return (
                                            <TableRow key={idMissionStakeholders}>
                                                <TableCell component="th" scope="row">{stakeholderName} </TableCell>
                                                <TableCell align="right">{stakeholderSurname}</TableCell>
                                                <TableCell align="right">{stakeholderCompany}</TableCell>
                                                <TableCell align="right">{stakeholderEmail}</TableCell>
                                                <TableCell align="right">
                                                    <Button variant="outlined" color="secondary"
                                                        data-id={idMissionStakeholders}
                                                        onClick={this.handleRemoveStakeholdersOnClick.bind(this)}>
                                                        Remove
                 									 </Button>
                                                </TableCell>
                                            </TableRow>
                                        )
                                    })}
                                </TableBody>
                            </Table>
                        </CardContent>
                    </Card>
                </Grid>
                {
                    //<Grid item xs={12} className="mt-1">
                    //    <Button variant="contained" color="primary" onClick={this.handleSaveOnClick.bind(this)} >
                    //        SAVE
                    //</Button>
                    //</Grid>
                }
            </Grid>
        );
    }
}




// WEBPACK FOOTER //
// ./src/pages/AssignMissionPage.js